// SIDE DRAWER
export const SIDE_DRAWER_MAX_WIDTH = 400;
export const SIDE_DRAWER_Z_INDEX = 1401;
export const SIDE_CHILD_DRAWER_Z_INDEX = 1500;
export const SIDE_DRAWER_BACKDROP_Z_INDEX = 1400;
// Popper-based controls (Autocomplete, Select, DatePicker) portal to <body> and
// default to theme.zIndex.modal (1300), which is BELOW the side drawers above -
// their dropdowns render but are painted behind the drawer paper and look empty.
// Must stay above SIDE_CHILD_DRAWER_Z_INDEX so poppers inside a child drawer work too.
export const SIDE_DRAWER_POPPER_Z_INDEX = 1600;

// HEADER
export const DRAWER_WIDTH: number = 360;
export const COLLAPSED_DRAWER_WIDTH: number = 57;
